import React, { useEffect, useRef } from "react";
import { BrowserRouter, Link } from "react-router-dom";
import Conteiner from "./pages/Conteiner";
import Header from "./components/Header";
import navImg from "./img/nav.png";
import navImg2 from "./img/nav2.png";
import gsap from "gsap";
import "./style/body.css";
import "./style/nav.css";
function App() {
  const navRef = useRef("");
  const ulRef = useRef("");
  useEffect(() => {
    const container = document.querySelector(".container");

    const tl = gsap.timeline({});
    const tl2 = gsap.timeline({});
    var header = document.querySelector("header");
    var ul = document.querySelectorAll("nav>ul>li>a");
    var btn = header.querySelector("button");
    btn.dataset.click = "false";
    btn.addEventListener("click", () => {
      if (btn.dataset.click == "false") {
        btn.dataset.click = "true";
        tl.to(navRef.current, { opacity: 1, pointerEvents: "all" }).fromTo(
          "nav>ul>li",
          { opacity: 0, x: -20 },
          { opacity: 1, x: 0, duration: 0.5, stagger: 0.15 }
        );
      } else {
        tl.to(navRef.current, { opacity: 0, pointerEvents: "none" });
        btn.dataset.click = "false";
      }
    });
    ul.forEach((a) => {
      a.addEventListener("click", () => {
        tl2
          .to(container, { opacity: 0 })
          .to(".ul_animation>li", {
            transform: "scaleX(1)",
            transformOrigin: "left",
            stagger: 0.1,
            duration: 0.7,
          })
          .to(ulRef.current.children, {
            transform: "scaleX(0)",
            transformOrigin: "right",
            stagger: 0.1,
            duration: 0.5,
          })
          .to(container, { opacity: 1 });
        tl.to(navRef.current, { backdropFilter: "blur(0px)" }).to(
          navRef.current,
          { opacity: 0, pointerEvents: "none" }
        );

        btn.dataset.click = "false";
      });
    });
  }, []);
  const memosvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-clr)"
    >
      <path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
    </svg>
  );
  const memoarrow = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-clr)"
    >
      <path d="M504-480 348-636q-11-11-11-28t11-28q11-11 28-11t28 11l184 184q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L404-268q-11 11-28 11t-28-11q-11-11-11-28t11-28l156-156Z" />
    </svg>
  );
  const home = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-clr)"
    >
      <path d="M160-200v-360q0-19 8.5-36t23.5-28l240-180q21-16 48-16t48 16l240 180q15 11 23.5 28t8.5 36v360q0 33-23.5 56.5T720-120H600q-17 0-28.5-11.5T560-160v-200q0-17-11.5-28.5T520-400h-80q-17 0-28.5 11.5T400-360v200q0 17-11.5 28.5T360-120H240q-33 0-56.5-23.5T160-200Z" />
    </svg>
  );
  const settings = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-clr)"
    >
      <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm112-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z" />
    </svg>
  );
  const exame = (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px"
     viewBox="0 -960 960 960" width="24px" fill="var(--svg-clr)">
      <path d="m297-581 149-243q6-10 15-14.5t19-4.5q10 0 19 4.5t15 14.5l149 243q6 10 6 21t-5 20q-5 9-14 14.5t-21 5.5H331q-12 0-21-5.5T296-540q-5-9-5-20t6-21ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-60v-240q0-17 11.5-28.5T160-420h240q17 0 28.5 11.5T440-380v240q0 17-11.5 28.5T400-100H160q-17 0-28.5-11.5T120-140Z" /></svg>
  )
  return (
    <BrowserRouter>
      <nav ref={navRef}>
        <div id="img">
          <img src={navImg} draggable="false" />
        </div>
        <ul>
          <li>
            {home}
            <Link to={"/"}>home</Link>
            <span>{memoarrow}</span>
          </li>
          <li>
            {memosvg}
            <Link to={"/memo"}>memo</Link>
            <span>{memoarrow}</span>
          </li>
          <li>
            {exame}
            <Link to={"/exame"}>exame</Link>
            <span>{memoarrow}</span>
          </li>
          <li>
            {settings}
            <Link to={"/edit_memo"}>edit memo</Link>
            <span>{memoarrow}</span>
          </li>
        </ul>
        <div id="img2">
          <img src={navImg2} draggable="false" />
        </div>
      </nav>
      <ul className="ul_animation" ref={ulRef}>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <Header />
      <Conteiner></Conteiner>
    </BrowserRouter>
  );
}

export default App;
